import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import split from 'lodash/split';
import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';

function sortAgents(a, b) {
  let result = 0;
  if (a.status > b.status) {
    result = 1;
  } else if (a.status < b.status) {
    result = -1;
  }
  if (result !== 0) {
    return result;
  }
  if (a.name > b.name) {
    result = 1;
  } else if (a.name < b.name) {
    result = -1;
  }
  return result;
}

export function fetchAgentSuccess(state, action) {
  const sortedData = action.payload.data.sort(sortAgents);

  return {
    ...state,
    agents: sortedData,
    showdetails: mapValues(keyBy(sortedData, 'id'), () => false),
    filterStatus: action.filterStatus,
  };
}

export function pollConnectionStateSuccess(state, action) {
  const oldDetails = state.showdetails;
  const agents = action.payload.data.sort(sortAgents);
  const showdetails =
    oldDetails === undefined
      ? {}
      : mapValues(keyBy(agents, 'id'), (val, id) => get(oldDetails, id, false));

  return {
    ...state,
    agents,
    showdetails,
  };
}

export function saveNameSuccess(state, action) {
  const agents = [...state.agents];
  const index = findIndex(state.agents, r => r.id === action.payload.id);

  if (index >= 0) {
    agents[index] = {
      ...agents[index],
      name: action.payload.name,
    };
  }

  return {
    ...state,
    agents: agents.sort(sortAgents),
  };
}

export function deleteAgentSuccess(state, action) {
  const agents = [...state.agents];
  const index = agents.findIndex(r => r.id === action.payload.id);
  if (index >= 0) {
    agents.splice(index, 1);
  }

  return {
    ...state,
    agents,
  };
}

export function updateAgentMonitorsSuccess(state, action) {
  const agents = [...state.agents];
  const links = split(action.payload.links.self, '/');
  // links[5] represents the agent ID
  // the path parameter is used to determine the agent ID because the payload may not contain the agent ID
  // if the agent does not have any monitors
  const index = agents.findIndex(agent => agent.id === links[5]);

  if (index >= 0) {
    agents[index] = {
      ...agents[index],
      monitors: action.payload,
    };
  }

  return {
    ...state,
    agents: agents.sort(sortAgents),
  };
}

export function toggleShowAllDetails(state) {
  const showAllDetails = !state.showAllDetails;
  const result = { ...state };
  result.showdetails = {};
  result.showAllDetails = showAllDetails;
  Object.keys(state.showdetails).forEach(key => {
    result.showdetails[key] = showAllDetails;
  });
  return result;
}

export function toggleShowDetail(state, action) {
  const toggleId = action.id;
  const result = { ...state };
  result.showdetails = {};
  let hasTrue = false;
  let hasFalse = false;
  Object.keys(state.showdetails).forEach(key => {
    if (key === toggleId) {
      result.showdetails[key] = !state.showdetails[key];
    } else {
      result.showdetails[key] = state.showdetails[key];
    }
    if (result.showdetails[key]) {
      hasTrue = true;
    } else {
      hasFalse = true;
    }
  });
  if (hasTrue && !hasFalse) {
    result.showAllDetails = true;
  } else if (!hasTrue && hasFalse) {
    result.showAllDetails = false;
  }
  return result;
}

export function switchActiveTab(state) {
  return {
    ...state,
    filterStatus: 'SHOW_ALL',
  };
}
